// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import hostConfig from '$config/frontend'
import { nothing } from './utils'

const browserHasShare = () => !!navigator.share && !!navigator.canShare

const isShareSupported = (shareData: {
  text?: string
  files?: File[]
  url?: string
  title?: string
}) => {
  if (!browserHasShare()) return false
  return Object.entries(shareData).every(([key, value]) =>
    navigator.canShare({ [key]: value }),
  )
}
export function shareFile(shareableFile: File, text?: string) {
  const shareData = {
    files: [shareableFile],
    ...(text && { text }),
  }
  const shareable = isShareSupported(shareData)

  return {
    shareable,
    onShare: shareable
      ? async () => {
          await navigator.share(shareData)
          window.gtag?.('event', 'share', {})
        }
      : nothing,
  }
}

export function shareLink(url: string, text?: string) {
  const shareData = { url, ...(text && { text }) }
  const shareable = isShareSupported(shareData)
  return {
    shareable,
    onShare: shareable
      ? async () => {
          await navigator.share(shareData)
          window.gtag?.('event', 'share', {})
        }
      : nothing,
  }
}

export function shareText(text: string) {
  const shareData = {
    text,
  }
  const shareable = isShareSupported(shareData)
  return {
    shareable,
    onShare: shareable ? () => navigator.share(shareData) : nothing,
  }
}

export function canShareLink() {
  return (
    browserHasShare() && navigator.canShare?.({ url: hostConfig.FRONT_HOST })
  )
}
